<div class="form-group m-form__group row">
	<!-- *ngIf="isComplaint && isComplaint.IsCompliant !== ''" -->
	<label class="col-form-label col-lg-1" *ngIf="column"></label>
	<label class="col-form-label col-lg-3 col-sm-12">
		Review Comments
	</label>
	<div class="col-lg-7 col-md-9 col-sm-12">
		<div class="alert alert-dismissible fade show m-alert m-alert--outline m-alert--air" role="alert" [ngClass]="(isComplaint === 'true' || isComplaint === true)?'complaint':'non-complaint'">
			<strong *ngIf="(isComplaint === 'true' || isComplaint === true); else elseBlock">
				Compliant
			</strong>
			<ng-template #elseBlock>
				<strong>Non-Compliant</strong>
			</ng-template>
			<br>
			<span *ngIf="description; else descriptionBlock">{{description}}</span>
			<ng-template #descriptionBlock>
				Comment not found
			</ng-template>
			<!-- <span *ngIf="isComplaint.documentReview">{{isComplaint.documentReview}}</span>
      <span *ngIf="isComplaint.NextReviewDateReview">{{isComplaint.NextReviewDateReview}}</span> -->
		</div>
	</div>
</div>